import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import GridElementContainer from '../../../GridElementContainer'
import ClassProgress from './ClassProgress'

import { selectRole } from '../../../../../../../routing/fetchingfunction/user/user.reducer'

const Classes = ({ containerClassName = '', className = '' }) => {
  const role = useSelector(selectRole)

  return (
    <GridElementContainer className={containerClassName} title="Classes">
      <div className={`flex flex-col items-start justify-start ${className}`}>
        <div className="text-xs flex items-center justify-between !border border-primary-450 !py-2 px-[10px] rounded-md w-full text-primary-100 !mb-2">
          <p className="!mr-3">
            Awaiting for approval: <span className="text-sm font-semibold">15</span>
          </p>
          <Link
            to={`/${role}/calendar`}
            className="rounded-[6px] bg-white border-primary-100 border-[1px] h-[26px] px-[10px] flex items-center justify-center hover:!bg-primary-100 hover:!text-white transition-colors duration-200 ease"
            variant="secondary"
          >
            Go to Calendar
          </Link>
        </div>
        <div className="w-full flex flex-col items-start justify-start">
          <ClassProgress
            className="!mb-2"
            color="success"
            title="Students back after intro class"
            value={32}
            percent={80}
          />
          <ClassProgress
            className="!mb-2"
            color="warning"
            title="Postponed"
            value={16}
            percent={40}
          />
          <div className="flex items-center justify-between w-full">
            <ClassProgress
              className="!mr-1"
              color="error"
              title="Canceled"
              value={4}
              percent={10}
            />
            <ClassProgress color="error" title="No-Show" value={29} percent={70} />
          </div>
        </div>
      </div>
      {/*<div className=" justify-content-between w-full">*/}
      {/*  <div className="h-11 borderViewLightPink w-100 me-2 my-2.5 flex flex-column justify-content-evenly align-items-center">*/}
      {/*    <div className="m-2 w-100 flex justify-content-between">*/}
      {/*            <span className="font-Inter font-medium ms-2.5 my-3 text-[#F67443] text-xs not-italic">*/}
      {/*              Awaiting for approval: <span className="font-bold">15</span>*/}
      {/*            </span>*/}
      {/*      <div className="me-2.5 my-2 goToCalendarBorder rounded px-2.5 py-1 bg-white flex align-items-center">*/}
      {/*        <span className="font-Inter text-[#F67443] font-semibold text-xs not-italic">Go to Calendar</span>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <div className="h-12 p-2.5 w-100 me-2 my-2.5 flex flex-column justify-content-evenly align-items-center border border-solid border-[#A6F4C5] bg-[#ECFDF3] rounded-md">*/}
      {/*    <div className="flex justify-content-between w-100 mb-1">*/}
      {/*      <span className="font-Inter not-italic font-medium text-xs text-[#12B76A]">Students back after intro class</span>*/}
      {/*      <span className="font-Inter not-italic font-semibold text-[10px] text-[#12B76A]">32 (80%)</span>*/}
      {/*    </div>*/}
      {/*    /!* <img src={"/assets/icon/Progress Bar Green.png"} className="w-100" /> *!/*/}
      {/*    <ApoloProgressBar bgColor={"bg-success-100"} mainColor={"bg-success-500"} percentage={80} />*/}
      {/*  </div>*/}
      {/*  <div className="h-12 p-2.5 w-100 me-2 my-2.5 flex flex-column justify-content-evenly align-items-center orangeProgressViewBorder bg-[#FFFAEB] rounded-md">*/}
      {/*    <div className="flex justify-content-between w-100 mb-1">*/}
      {/*      <span className="font-Inter not-italic font-medium text-xs text-[#F79009]">Postponed</span>*/}
      {/*      <span className="font-Inter not-italic font-semibold text-[10px] text-[#F79009]">4 (10%)</span>*/}
      {/*    </div>*/}
      {/*    <ApoloProgressBar bgColor={"bg-warning-100"} mainColor={"bg-warning-500"} percentage={10} />*/}
      {/*  </div>*/}
      {/*  <div className="w-100 me-2 my-2.5 flex">*/}
      {/*    <div className="h-12 p-2.5 w-100 me-1 flex flex-column justify-content-evenly align-items-center redProgressViewBorder bg-[#FEF3F2] rounded-md">*/}
      {/*      <div className="flex justify-content-between w-100 mb-1">*/}
      {/*        <span className="font-Inter not-italic font-medium text-xs text-[#F04438]">Cancelled</span>*/}
      {/*        <span className="font-Inter not-italic font-semibold text-[10px] text-[#F04438]">16 (40%)</span>*/}
      {/*      </div>*/}
      {/*      <ApoloProgressBar bgColor={"bg-red-100"} mainColor={"bg-red-500"} percentage={40} />*/}
      {/*    </div>*/}
      {/*    <div className="h-12 p-2.5 w-100 flex flex-column justify-content-evenly align-items-center redProgressViewBorder bg-[#FEF3F2] rounded-md">*/}
      {/*      <div className="flex justify-content-between w-100 mb-1">*/}
      {/*        <span className="font-Inter not-italic font-medium text-xs text-[#F04438]">Didn’t Visit</span>*/}
      {/*        <span className="font-Inter not-italic font-semibold text-[10px] text-[#F04438]">29 (70%)</span>*/}
      {/*      </div>*/}
      {/*      <ApoloProgressBar bgColor={"bg-red-100"} mainColor={"bg-red-500"} percentage={70} />*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </GridElementContainer>
  )
}

export default Classes
